import React from 'react';

const Footer = () => {
  return (

    <div className="footer-background fixed-end">
        <div className="">
          <div className="row footer-row">
            {/* <div className="col-12 text-right">
              <a
                className="btn"
                href="#scroll"
                onClick={(event) => scrollTo(event, "home")}
              >
                <i className="simple-icon-arrow-up" />
              </a>
            </div> */}
            <br />
          </div>
        </div>
        <div className=" copyright pt-1 pb-1">
          <div className="row">
            <div className="col-12" />
            <div className="col-12 text-center">
              <p className="mb-0">
                50 California Street, Suite 1500, San Francisco, CA 94111
              </p>
              <p className="mb-0">info@teamanics.com</p>
            </div>
          </div>
        </div>
        <div className=" copyright pt-5 pb-5">
          <div className="row">
            <div className="col-12" />
            <div className="col-12 text-center">
              <p className="mb-0">© 2020 - 2022 Teamanics™</p>
              <p className="mb-0">
                Teamanics is a trademark and service of Metabyte, Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Footer;
